"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Truck, Package, ArrowRight, Layers } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const componentsList = [{
  name: "Motion Base & Bull Body",
  detail: "Packed per order requirements"
}, {
  name: "Operator Console",
  detail: "Packed per order requirements"
}, {
  name: "Inflatable Safety Arena",
  detail: "Packed per order requirements"
}, {
  name: "Blower",
  detail: "Packed per order requirements"
}, {
  name: "Hardware & Accessories",
  detail: "Packed per order requirements"
}];
export default function Shipping() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="shippinginflatablebull" data-nav="light" className="bg-background text-foreground py-20 md:py-28 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Main Content Column */}
          <motion.div initial={shouldReduceMotion ? false : {
          opacity: 0,
          y: 20
        }} whileInView={shouldReduceMotion ? {} : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: "easeOut"
        }} className="lg:col-span-7 flex flex-col items-start">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-muted border border-border text-xs uppercase tracking-wider font-mono text-muted-foreground mb-6">
              <Truck className="size-3.5 text-primary" />
              <span>Commercial Freight &amp; Logistics</span>
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight text-foreground mb-8">
              Shipping an Inflatable Mechanical Bull
            </h2>

            <div className="space-y-6 text-base sm:text-lg text-muted-foreground leading-relaxed">
              <p>
                A complete inflatable mechanical bull may involve several large components, including the powered bull, controller, folded inflatable, blower and accessories. Packing arrangements can therefore vary by order.
              </p>
              <p>
                Delivery requirements depend on the actual package, packed dimensions, weight, destination and unloading access. Confirm the delivery arrangement for the exact machine rather than assuming every system ships the same way.
              </p>
            </div>

            <div className="mt-10 pt-6 border-t border-border w-full flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto uppercase font-mono tracking-wider text-xs font-semibold">
                <Link to="/ShippingWarrantyAndOrderingPage" className="inline-flex items-center gap-2">
                  <span>VIEW SHIPPING INFORMATION</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>
          </motion.div>

          {/* Industrial Freight Breakdown Card */}
          <motion.div initial={shouldReduceMotion ? false : {
          opacity: 0,
          x: 20
        }} whileInView={shouldReduceMotion ? {} : {
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: "easeOut"
        }} className="lg:col-span-5">
            <div className="bg-card border border-border p-6 sm:p-8 shadow-md relative">
              <div className="flex items-center justify-between border-b border-border pb-4 mb-6">
                <div className="flex items-center gap-2">
                  <Package className="size-5 text-primary" />
                  <span className="font-serif font-bold text-lg uppercase tracking-wide text-card-foreground">
                    Typical Package Components
                  </span>
                </div>
              </div>

              <p className="text-xs uppercase font-mono text-muted-foreground mb-4 flex items-center gap-1.5">
                <Layers className="size-3.5" />
                <span>Typical Modular Component Package</span>
              </p>

              <ul className="space-y-3 font-mono text-xs">
                {componentsList.map((item, index) => <li key={item.name} data-index={index} className="flex flex-col sm:flex-row sm:items-center justify-between p-3 bg-muted/40 border border-border/80 gap-1 sm:gap-2">
                    <span className="font-semibold text-foreground">{item.name}</span>
                    <span className="text-muted-foreground text-[11px] sm:text-right">{item.detail}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}